import { createTheme } from '@mui/material/styles';
import * as colors from '@mui/material/colors';

let globalTheme = createTheme({
    body: {
        margin: '0'
    },
    palette: {
        primary: colors.indigo,
        secondary: {
            main: colors.blue[300]
        },
        warning: colors.orange,
        rag: {
            green: colors.green[500],
            amber: colors.amber[500],
            red: "#E4002B",// red isn't red colors.red[500]"",
            clear: colors.grey[500]
        },
        header: {
            background: "#202020"
        },
        type: 'light'
    },
    typography: {
        body: {
            fontSize: "0.9rem",
            fontWeight: 600,
            fontFamily: "'Roboto', 'Helvetica Neue', 'Arial', 'sans-serif'",
        },
        body2: {
            fontSize: "0.9rem",
            fontWeight: 600,
            fontFamily: "'Roboto', 'Helvetica Neue', 'Arial', 'sans-serif'",
        },
        header: {
            fontSize: "1.1rem",
            fontWeight: 600
        },
        fontSize: 12,
        fontFamily: [
            'Roboto',
            '"Helvetica Neue"',
            'Arial',
            'sans-serif',
            '"Apple Color Emoji"',
            '"Segoe UI Emoji"',
            '"Segoe UI Symbol"',
        ].join(',')
    },
    nav: { height: 0 },
    grid: {
        header: {
            hideText: {
                visibility: "hidden"
            }
        }
    }
});

globalTheme = createTheme(globalTheme, {
    table: {
        fontFamily: globalTheme.typography.fontFamily,
        fontSize: globalTheme.typography.fontSize
    },
    grid: {
        border: `1px solid ${globalTheme.palette.type === 'light' ? '#f0f0f0' : '#303030'}`,
        color: globalTheme.palette.type === 'light' ? 'rgba(0,0,0,.85)' : 'rgba(255,255,255,0.85)',
        fontFamily: [
            'Roboto',
            '"Helvetica Neue"',
            'Arial',
            'sans-serif',
            '"Apple Color Emoji"',
            '"Segoe UI Emoji"',
            '"Segoe UI Symbol"',
        ].join(','),
        fontWeight: 400,
        WebkitFontSmoothing: 'auto',
        letterSpacing: 'normal',
        '& .MuiDataGridColumnsContainer': {
            backgroundColor: globalTheme.palette.type === 'light' ? '#fafafa' : '#1d1d1d',
        },
        '& .MuiDataGridIconSeparator': {
            display: 'none',
        },
        '& .MuiDataGridColCell,, .MuiDataGridCell': {
            borderRight: `1px solid ${globalTheme.palette.type === 'light' ? '#f0f0f0' : '#303030'
                }`,
        },
        '& .MuiDataGridColumnsContainer, .MuiDataGridCell': {
            borderBottom: `1px solid ${globalTheme.palette.type === 'light' ? '#f0f0f0' : '#303030'
                }`,
        },
        '& .MuiDataGridCell': {
            color:
                globalTheme.palette.type === 'light'
                    ? 'rgba(0,0,0,.85)'
                    : 'rgba(255,255,255,0.65)',
        },
        '& .MuiPaginationItemRoot': {
            borderRadius: 0,
        },
        '& .MuiCheckboxRoot svg': {
            width: 16,
            height: 16,
            backgroundColor: 'transparent',
            border: `1px solid ${globalTheme.palette.type === 'light' ? '#d9d9d9' : 'rgb(67, 67, 67)'
                }`,
            borderRadius: 2,
        },
        '& .MuiCheckboxRoot svg path': {
            display: 'none',
        },
        '& .MuiCheckboxRoot.MuiChecked:not(.MuiCheckboxIndeterminate) svg': {
            backgroundColor: '#1890ff',
            borderColor: '#1890ff',
        },
        '& .MuiCheckboxRoot.MuiChecked .MuiIconButtonLabel:after': {
            position: 'absolute',
            display: 'table',
            border: '2px solid #fff',
            borderTop: 0,
            borderLeft: 0,
            transform: 'rotate(45deg) translate(-50%,-50%)',
            opacity: 1,
            transition: 'all .2s cubic-bezier(.12,.4,.29,1.46) .1s',
            content: '""',
            top: '50%',
            left: '39%',
            width: 5.71428571,
            height: 9.14285714,
        },
        '& .MuiCheckboxRoot.MuiCheckboxIndeterminate .MuiIconButtonLabel:after': {
            width: 8,
            height: 8,
            backgroundColor: '#1890ff',
            transform: 'none',
            top: '39%',
            border: 0,
        },
        '& .MuiTableCellRoot.MuiTablePaginationRoot': {
            borderBottom: 'none'
        },
        '& .MuiDataGridWindow': {
            overflowY: 'auto',
            overflowX: 'hidden'
        }
    }
});

export default globalTheme;